import { render, staticRenderFns } from "./BusinessCouncilPage.vue?vue&type=template&id=e214e92a&scoped=true&"
import script from "./BusinessCouncilPage.vue?vue&type=script&lang=js&"
export * from "./BusinessCouncilPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e214e92a",
  null
  
)

export default component.exports